import { ORDER_METHODS } from '../../../../../services/exports/Constants';

export default {
  empty_list: 'Brak grup modyfikatorów. Utwórz nową.',
  fields: {
    name: 'Nazwa',
    external_id: '{{integration}} ref',
    prices: 'Ceny',
    available: 'Dostępne',
    status: 'Status',
    statuses: {
      good: 'Dobry',
      bad: 'Zły',
      medium: 'Średni',
    },
  },
  order_method_prices: {
    base: 'Podstawowa',
    [ORDER_METHODS.pickup]: 'Odbiór',
    [ORDER_METHODS.delivery]: 'Dostawa',
    [ORDER_METHODS.on_site]: 'Zamawianie przy stoliku',
  },
  labels: {
    visible: 'Widoczne w menu',
    hidden: 'Wszystkie ukryte',
  },
  buttons: {
    add_modifier: 'Dodaj modyfikator',
    delete_modifier_one: 'Usuń modyfikator',
    delete_modifier_few: 'Usuń modyfikatory',
    delete_modifier_many: 'Usuń modyfikatory',
    delete_modifier_other: 'Usuń modyfikatory',
    show_modifier_group: 'Pokaż grupę modyfikatorów',
    close_modifier_group: 'Zamknij grupę modyfikatorów',
    edit: 'Edytuj',
    duplicate: 'Duplikuj',
    history: 'Historia',
  },
  toasts: {
    failed_to_duplicate_modifier_group: 'Nie udało się zduplikować grupy modyfikatorów',
    modifier_group_duplicated_successfully: 'Grupa modyfikatorów zduplikowana pomyślnie',
    failed_to_duplicate_modifier: 'Nie udało się zduplikować modyfikatora',
    modifier_duplicated_successfully: 'Modyfikator zduplikowany pomyślnie',
  },
};
